module.exports = __webpack_public_path__ + "static/media/businesses-icon-2.d66e62da.svg";